
$(document).ready(function(){
  
  // General Message
  $('.generalmessage').prependTo('header');

  // Email signup text
  $('.afterContent .emailSignupText').html(`
      Join the Email Fan Club!
      <span>BE IN THE KNOW</span>
  `);
  $('.afterContent .inputFieldTextbox').val('')
  $('.afterContent .inputFieldTextbox').attr('placeholder', 'Enter Email Address');
  $('.afterContent .emailSubmitButton').text('Subscribe');


  // subpage hero images
  const dynamicPage = $('.dynamicPageContainer');
  if (dynamicPage.length) {
    const firstSection = $('.entityContainerRow.rowIndex-1');
    const firstSectionTitle = firstSection.find('.sectionHeading');
    if (firstSectionTitle.text() === 'hero-image') {
      $('body').addClass('has-subpage-hero');
      const img = firstSection.find('.ImageModule img').attr('data-src');

      $(`<div class="page-hero-image" style="background-image: url('${img}');"></div>`).insertAfter('.header');
    }
  }

  // set header ticket button url
  const tixBtnURL = $('.header .tickets').attr('href');
  $('.custom-buy-tickets-btn').attr('href', tixBtnURL);

});

$(window).load(function() {
  // copy countdown to header
  setTimeout(function() {
    const cd = $('#siteInfoBannerWidget');
    if (cd) {
      const cdInnerHTML = cd.html();
      $(`<div class="h-countdown" style="display:none;">${cdInnerHTML}</div>`).insertAfter('.header-logo');
      $('.h-countdown').fadeIn();
    }
  }, 1250);
});
